/**
* @name: xm-file-upload-infos
* @author: weiyong
* @date: 2024-01-30 19:59
* @description：xm-file-upload-infos
* @update: 2024-01-30 19:59
* @remark: HHHH
*/
<template>
  <div class="flex-div xm-file-input" style="justify-content: center;align-items: center;flex-wrap: wrap;pointer-events: none;">
    <div class="ant-upload-drag-icon">
      <inbox-outlined></inbox-outlined>
    </div>
    <div class="ant-upload-text w100b">点击或者拖拽文件到本区域上传</div>
    <div style="color:#777;" v-if="showFileTypes">支持扩展名：{{ accept.join(",") }}</div>
    <div class="w100b" style="color:#777;font-size: 12px;" v-html="ctlProps.info"></div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xm-file-upload-infos",
});
</script>

<script lang="ts" setup>
import {InboxOutlined} from "@ant-design/icons-vue";

interface propTypes {
  accept: any,
  showFileTypes: boolean,
  ctlProps: any,
}

const props = withDefaults(defineProps<propTypes>(), {
  accept: [],
  ctlProps: {},
  showFileTypes: false,
})
</script>

<style type="text/css" lang="less">

</style>
